// @ts-nocheck
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { StyledImgWrapper } from "@store/MobiusOverrides/Img/Img";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface BlogProps {
    blockSubheading?: TypographyPresentationProps;
    tileClickable?: ClickablePresentationProps;
    imageWrapper?: InjectableCss;
    surtitle?: TypographyPresentationProps;
    publishDate?: InjectableCss;
}

export const blogProps: BlogProps = {
    blockSubheading: {
        css: css`
            ${spacingStyles(pxToRem(-12))}
            display: block;
            color: ${getColor("text.accent")};
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
            ${x =>
                breakpointValues(
                    [
                        x.theme.design.typography.size.base,
                        null,
                        x.theme.design.typography.size.large,
                        null,
                        x.theme.design.typography.size.larger,
                    ],
                    "font-size",
                )}
        `,
    },
    tileClickable: {
        css: css`
            position: absolute;
            top: 0;
            bottom: 0;
            overflow: hidden;
            width: 100%;
            height: 100%;
            z-index: 1;
            text-indent: -9999rem;
            white-space: nowrap;

            &:hover {
                ~ div header,
                ~ section header {
                    a {
                        color: ${getColor("text.linkHover")};
                    }
                }
            }
        `,
    },
    imageWrapper: {
        css: css`
            overflow: hidden;

            ${StyledImgWrapper} {
                width: 100%;
                height: 100%;
            }
        `,
    },
    surtitle: {
        css: css`
            text-transform: uppercase;

            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.smallest};
                line-height: ${theme.design.typography.lineHeight.small};
            `};
        `,
    },
    publishDate: {
        css: css`
            display: block;
            color: ${getColor("text.accent")};

            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.smallest};
                line-height: ${theme.design.typography.lineHeight.base};
            `};
        `,
    },
};
